module.exports = __webpack_public_path__ + "static/Dolores-and-Co-Black (2)-671aad1596592045d187739e7546752e.png";